<template>
  <div class="login-page">
    <div class="login-card">
      <h1 class="login-title">投研系统</h1>
      <el-form ref="form" :model="form" :rules="rules" label-width="0" @submit.native.prevent="submit">
        <el-form-item prop="username">
          <el-input
            v-model="form.username"
            prefix-icon="el-icon-user"
            placeholder="用户名"
            autocomplete="username"
            @keyup.enter.native="submit"
          />
        </el-form-item>
        <el-form-item prop="password">
          <el-input
            v-model="form.password"
            prefix-icon="el-icon-lock"
            type="password"
            show-password
            placeholder="密码"
            autocomplete="current-password"
            @keyup.enter.native="submit"
          />
        </el-form-item>
        <el-button type="primary" class="login-btn" :loading="loading" @click="submit">
          登录
        </el-button>
      </el-form>
    </div>
  </div>
</template>

<script>
import { login } from '../utils/authApi.js'

export default {
  name: 'LoginPage',
  data() {
    return {
      loading: false,
      form: {
        username: '',
        password: '',
      },
      rules: {
        username: [{ required: true, message: '请输入用户名', trigger: 'blur' }],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }],
      },
    }
  },
  methods: {
    submit() {
      this.$refs.form.validate(async valid => {
        if (!valid) return
        this.loading = true
        try {
          const data = await login(this.form.username, this.form.password)
          this.$emit('success', data)
        } catch (err) {
          this.$message.error(err.message || '登录失败')
        } finally {
          this.loading = false
        }
      })
    },
  },
}
</script>

<style scoped>
.login-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  padding: 24px 20px;
  background: linear-gradient(135deg, #eef2f7 0%, #f5f7fa 100%);
}

.login-card {
  width: 100%;
  max-width: 380px;
  padding: 36px 32px 28px;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);
}

@media (max-width: 480px) {
  .login-page {
    padding: 24px 24px;
  }

  .login-card {
    padding: 28px 20px 22px;
  }
}

.login-title {
  margin: 0 0 8px;
  text-align: center;
  font-size: 24px;
  color: #303133;
}

.login-btn {
  width: 100%;
}
</style>
